import { extendServiceContainer } from '@iotize/tap';
import { InterfaceService } from './service';

declare module '@iotize/tap/lib/service-container' {
  interface ServiceContainer {
    interface: InterfaceService;
  }
}

export const _TAP_SERVICE_EXTENSION_INTERFACE_ = extendServiceContainer(
  'interface',
  InterfaceService,
);
